import { Card, Grid, useTheme } from "@mui/material";
import { gridSpacing } from "constant";

interface StyledCardProps {
  children: React.ReactNode;
}

export const StyledCard = ({ children }: StyledCardProps) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        marginBottom: theme.spacing(gridSpacing),
        // border: card === false ? 'none' : '1px solid',
        // borderColor: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.primary[200] + 75,
        background: theme.palette.background.default,
        width: "100%",
        display: "flex",
        alignContent: "stretch",
        justifyContent: "stretch",
        justifyItems: "stretch",
      }}
    >
      {children}
    </Card>
  );
};
